import { jwtDecode } from 'jwt-decode';

export function decodeToken<T>(token: string): T {
  try {
    return jwtDecode<T>(token);
  } catch (error) {
    throw Error('Failed to decode token');
  }
}

export function isTokenExpired(exp: number): boolean {
  const currentTime = Math.floor(Date.now() / 1000);

  return currentTime >= exp;
}
